// {
//   "name": "iconic-letter-animation-third.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get("iconic-letter-animation-third")) {
    return;
  }
  class IconicLetterAnimationThird extends HTMLElement {
    constructor() {
      super();
      this.initAnimation = this.initAnimationThird.bind(this);
    }
    connectedCallback() {
      this.initAnimationThird();

      if (Shopify.designMode) {
        this.addShopifyListeners();
      }
    }
    disconnectedCallback() {
      if (Shopify.designMode) {
        this.removeShopifyListeners();
      }
    }
    addShopifyListeners() {
      document.addEventListener("shopify:section:load", this.initAnimation);
      document.addEventListener("shopify:section:unload", this.initAnimation);
      document.addEventListener("shopify:section:select", this.initAnimation);
      document.addEventListener("shopify:section:deselect", this.initAnimation);
      document.addEventListener("shopify:section:reorder", this.initAnimation);
      document.addEventListener("shopify:block:select", this.initAnimation);
      document.addEventListener("shopify:block:deselect", this.initAnimation);
    }

    removeShopifyListeners() {
      document.removeEventListener("shopify:section:load", this.initAnimation);
      document.removeEventListener("shopify:section:unload", this.initAnimation);
      document.removeEventListener("shopify:section:select", this.initAnimation);
      document.removeEventListener("shopify:section:deselect", this.initAnimation);
      document.removeEventListener("shopify:section:reorder", this.initAnimation);
      document.removeEventListener("shopify:block:select", this.initAnimation);
      document.removeEventListener("shopify:block:deselect", this.initAnimation);
    }
    initAnimationThird() {
      const sections = document.querySelectorAll("[data-iconic-letter-animation]");
      sections.forEach((section) => {
        const items = section.querySelectorAll(".iconic-animation-3 .iconic-letter-item p");
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.style.opacity = "1";
                entry.target.style.transform = "translateY(0) scale(1) rotate(0)";
                entry.target.classList.add("in-view");
              } else {
                entry.target.style.opacity = "0";
                entry.target.style.transform = "translateY(50px) scale(0.8) rotate(-5deg)";
                entry.target.classList.remove("in-view");
              }
            });
          },
          { threshold: 0.2 }
        );

        items.forEach((item) => observer.observe(item));
      });
    }
  }
  customElements.define( "iconic-letter-animation-third", IconicLetterAnimationThird );
})();

